export const SETCUSTOMERGROUPLIST = "SETCUSTOMERGROUPLIST";
export const SETCURRENCYLIST = "SETCURRENCYLIST";
export const SETEMPLIST = "SETEMPLIST";
export const SETINDUSTRYLIST = "SETINDUSTRYLIST";
export const SETSTATELIST = "SETSTATELIST";
export const SETCOUNTRYLIST = "SETCOUNTRYLIST";
export const SETSERIESLIST = "SETSERIESLIST";